import NewDesign from 'components/NewDesign';
import React from 'react';
import JSXCode from '../../Components/JSXCode';
import Props from '../../Components/Props';

const TabSeparator = () => {
  return (
    <div className='component:TabSeparator'>
      <div>Box A</div>
      <NewDesign.Separator className='tw-my-2' />
      <div>Box B</div>

      <div className='tw-my-2'>
        <JSXCode
          code={`<div>Box A</div>
      <NewDesign.Separator className='tw-my-2' />
<div>Box B</div>`}
        />
      </div>

      <Props
        source={[
          {
            prop: 'asChild',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'orientation',
            type: '"horizontal" | "vertical"',
            default: 'undefined',
          },
          {
            prop: 'decorative',
            type: 'boolean',
            default: 'undefined',
          },
        ]}
      />
    </div>
  );
};

export default TabSeparator;
